import { getCustomField } from "@/lib/bigcommerce/utils/bigcommerceCustomFieldsUtils";
import { ProductData } from "@/lib/5874/types";
import { ProductListItemType } from "@/lib/bigcommerce-b2b/types";

export const CertificationMessageSize = {
	SMALL: "small",
	LARGE: "large",
} as const;

export type CertificationMessageSize =
	(typeof CertificationMessageSize)[keyof typeof CertificationMessageSize];

export const findProductCertifications = (
	product: ProductData | ProductListItemType | undefined,
) => {
	if (!product) return;

	const certificationsRequired = getCustomField(
		product,
		"Akeneo|CourseCertification",
	)
		?.value?.split(",")
		.map((cert) => cert.trim());

	const cleanCertsRequired = certificationsRequired?.map((c) =>
		c.trim().replace(/[_]/g, " "),
	);

	return cleanCertsRequired;
};
